var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { themeGet, position, top, left, right, space, display, justifyContent, alignItems, fontSize, border, borderRadius, } from 'styled-system';
import { size } from 'polished';
import GlideCarousel from './GlideCarousel';
import { Link } from '../Link';
import { themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, } from '../../theme/system-utilities';
import VisuallyHidden from '../VisuallyHidden';
import { LocaleConsumer } from '../../providers/LocaleProvider';
import arrow from '../../assets/icons/arrow-left.svg';
import arrowHoverState from '../../assets/icons/arrow-left-hover-state.svg';
var ControlsArrow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: translateY(-50%);\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: translateY(-50%);\n"])), position, top, left, right);
ControlsArrow.defaultProps = {
    position: 'absolute',
    top: '50%',
};
var ControlsArrowLeft = styled(ControlsArrow)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
ControlsArrowLeft.defaultProps = __assign(__assign({}, ControlsArrow.defaultProps), { left: '0' });
var ControlsArrowRight = styled(ControlsArrow)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
ControlsArrowRight.defaultProps = __assign(__assign({}, ControlsArrow.defaultProps), { right: '0' });
var PrevNextButton = styled.button(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  background-color: white;\n  box-shadow: ", ";\n  opacity: 0.9;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    border: 1px solid ", ";\n    box-shadow: none;\n  }\n\n  &[disabled] {\n    opacity: 0.5;\n  }\n\n  &[disabled] {\n    display: none;\n  }\n"], ["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  background-color: white;\n  box-shadow: ",
    ";\n  opacity: 0.9;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    border: 1px solid ", ";\n    box-shadow: none;\n  }\n\n  &[disabled] {\n    opacity: 0.5;\n  }\n\n  &[disabled] {\n    display: none;\n  }\n"])), display, justifyContent, alignItems, themeWidth, themeHeight, space, border, borderRadius, position, function (_a) {
    var controlShadow = _a.controlShadow, props = __rest(_a, ["controlShadow"]);
    return controlShadow || "0 0 0 1px " + themeGet('colors.gray.5')(props);
}, themeGet('colors.gray.10'));
PrevNextButton.defaultProps = {
    display: ['none', 'flex'],
    justifyContent: 'center',
    alignItems: 'center',
    themeWidth: 6,
    arrowSize: '22px',
    themeHeight: 6,
    p: 0,
    border: 'none',
    borderRadius: '100%',
};
var Arrow = styled.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var arrowSize = _a.arrowSize;
    return size(arrowSize);
});
Arrow.defaultProps = {
    arrowSize: '22px',
    src: arrow,
};
var PrevButton = styled(PrevNextButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), function (_a) {
    var shiftY = _a.shiftY;
    return shiftY && 'transform: translateY(-50%);';
}, function (_a) {
    var withOpacity = _a.withOpacity;
    return withOpacity && 'opacity: 0.45;';
});
var NextButton = styled(PrevNextButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ",
    "\n"])), function (_a) {
    var withOpacity = _a.withOpacity;
    return withOpacity && 'opacity: 0.45;';
}, function (_a) {
    var shiftY = _a.shiftY;
    return "transform: " + (shiftY ? 'translateY(-50%)' : '') + " rotate(180deg);";
});
var BottomCenterControlsGroup = styled.ul(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  list-style: none;\n  transform: translateY(100%) translateY(16px);\n"], ["\n  ", ";\n  ", ";\n  list-style: none;\n  transform: translateY(100%) translateY(16px);\n"])), display, space);
BottomCenterControlsGroup.defaultProps = {
    display: 'flex',
    m: 0,
    p: 0,
};
var ControlsItem = styled.li(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), space);
ControlsItem.defaultProps = {
    mx: 1,
};
var ControlsItemButton = styled.button(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: none;\n  background-color: ", ";\n\n  &[disabled] {\n    background-color: ", ";\n  }\n"], ["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: none;\n  background-color: ", ";\n\n  &[disabled] {\n    background-color: ", ";\n  }\n"])), display, space, border, borderRadius, themeWidth, themeHeight, themeGet('colors.gray.5'), themeGet('colors.gray.10'));
ControlsItemButton.defaultProps = {
    display: 'block',
    themeWidth: 2,
    themeHeight: 2,
    m: 0,
    p: 0,
    border: 'none',
    borderRadius: '100%',
};
var SeeAllLink = styled(Link)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  text-decoration: none;\n\n  &::after {\n    content: '';\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    background-image: url(", ");\n    background-position: center;\n    background-size: 22px;\n    background-repeat: no-repeat;\n    transform: rotate(180deg);\n  }\n\n  &:hover {\n    &::after {\n      background-image: url(", ");\n    }\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  text-decoration: none;\n\n  &::after {\n    content: '';\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    background-image: url(", ");\n    background-position: center;\n    background-size: 22px;\n    background-repeat: no-repeat;\n    transform: rotate(180deg);\n  }\n\n  &:hover {\n    &::after {\n      background-image: url(", ");\n    }\n  }\n"])), display, space, fontSize, themeWidth, themeMaxWidth, themeHeight, themeMaxHeight, arrow, arrowHoverState);
SeeAllLink.defaultProps = __assign(__assign({}, Link.defaultProps), { display: 'inline-flex', themeWidth: 4, themeMaxWidth: 4, themeHeight: 4, themeMaxHeight: 4, pb: [4, '28px', '42px'] });
export var BottomCenterControls = function (_a) {
    var goToSlide = _a.goToSlide, slideCount = _a.slideCount, currentSlide = _a.currentSlide, className = _a.className;
    return (React.createElement(BottomCenterControlsGroup, { className: className }, Array.from({ length: slideCount }, function (_, index) { return (React.createElement(ControlsItem, { key: index },
        React.createElement(ControlsItemButton, { onClick: function () { return goToSlide(index); }, disabled: currentSlide === index, "data-testid": "carousel-control-goto-" + index },
            React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(VisuallyHidden, null, l10n.replace.t('h24_go_to_item', { number: index + 1 }))); })))); })));
};
var getControlsMarginBottom = function (isVisualNavigation, mb) {
    return mb !== undefined
        ? mb
        : isVisualNavigation // @TODO: Remove isVisualNavigation and other hardcoded values by refactoring it
            ? [null, '-18px', '-2px']
            : ['32px', 0];
};
var getControlsPositionX = function (isVisualNavigation, positionX) { return (isVisualNavigation ? positionX : 0); };
export var CenterLeftControls = function (_a) {
    var previousSlide = _a.previousSlide, currentSlide = _a.currentSlide, slideCount = _a.slideCount, slidesToShow = _a.slidesToShow, wrapAround = _a.wrapAround, isVisualNavigation = _a.isVisualNavigation, buttonSize = _a.size, arrowSize = _a.arrowSize, withOpacity = _a.withOpacity, shiftY = _a.shiftY, mb = _a.mb, leftProp = _a.left, displayProp = _a.display, positionTop = _a.positionTop, props = __rest(_a, ["previousSlide", "currentSlide", "slideCount", "slidesToShow", "wrapAround", "isVisualNavigation", "size", "arrowSize", "withOpacity", "shiftY", "mb", "left", "display", "positionTop"]);
    var disabled = slideCount === 1 ||
        (isVisualNavigation && currentSlide === 0) ||
        (!wrapAround && currentSlide === 0) ||
        slideCount <= slidesToShow;
    return (React.createElement(ControlsArrowLeft, { left: getControlsPositionX(isVisualNavigation, leftProp), "data-testid": "carousel-control-previous", top: positionTop },
        React.createElement(PrevButton, __assign({ themeHeight: buttonSize, themeWidth: buttonSize, withOpacity: withOpacity || !isVisualNavigation, shiftY: shiftY && isVisualNavigation, mb: getControlsMarginBottom(isVisualNavigation, mb), disabled: disabled, display: displayProp, onClick: previousSlide }, props),
            React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(Arrow, { arrowSize: arrowSize, alt: l10n.t('h24_carousel_prev_item') })); }))));
};
CenterLeftControls.defaultProps = {
    isVisualNavigation: false,
    slidesToShow: 1,
    shiftY: true,
};
export var CenterRightControls = function (_a) {
    var canScrollToTheLastSlide = _a.canScrollToTheLastSlide, nextSlide = _a.nextSlide, slideCount = _a.slideCount, currentSlide = _a.currentSlide, wrapAround = _a.wrapAround, isVisualNavigation = _a.isVisualNavigation, slidesToShow = _a.slidesToShow, seeAllLink = _a.seeAllLink, buttonSize = _a.size, arrowSize = _a.arrowSize, withOpacity = _a.withOpacity, shiftY = _a.shiftY, mb = _a.mb, rightProp = _a.right, displayProp = _a.display, positionTop = _a.positionTop, props = __rest(_a, ["canScrollToTheLastSlide", "nextSlide", "slideCount", "currentSlide", "wrapAround", "isVisualNavigation", "slidesToShow", "seeAllLink", "size", "arrowSize", "withOpacity", "shiftY", "mb", "right", "display", "positionTop"]);
    var isAtCarouselEnd = canScrollToTheLastSlide
        ? currentSlide + 1 === slideCount
        : currentSlide >= slideCount - slidesToShow;
    if (isVisualNavigation && seeAllLink && isAtCarouselEnd) {
        return (React.createElement(ControlsArrowRight, null,
            React.createElement(SeeAllLink, { "data-testid": "see-all-link", fontSize: 4, lineHeight: 3, textDecoration: "underline", href: seeAllLink.href }, seeAllLink.label)));
    }
    var disabled = slideCount === 1 ||
        (isVisualNavigation && isAtCarouselEnd) ||
        (!wrapAround && isAtCarouselEnd) ||
        slideCount <= slidesToShow;
    return (React.createElement(ControlsArrowRight, { right: getControlsPositionX(isVisualNavigation, rightProp), "data-testid": "carousel-control-next", top: positionTop },
        React.createElement(NextButton, __assign({ themeHeight: buttonSize, themeWidth: buttonSize, withOpacity: withOpacity || !isVisualNavigation, shiftY: shiftY && isVisualNavigation, mb: getControlsMarginBottom(isVisualNavigation, mb), disabled: disabled, display: displayProp, onClick: nextSlide }, props),
            React.createElement(LocaleConsumer, null, function (l10n) { return (React.createElement(Arrow, { arrowSize: arrowSize, alt: l10n.t('h24_carousel_next_item') })); }))));
};
CenterRightControls.defaultProps = {
    shiftY: true,
    isVisualNavigation: false,
    slidesToShow: 1,
    seeAllLink: null,
};
export var Carousel = GlideCarousel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
